/* globals $, stage_language */

var navigation = document.getElementById('main-navigation'),
  mobileBreakPoint = 1210,
  displayedBox = null,
  allButtons,
  megaMenuButtons,
  megaMenuContainers,
  navigationItems;

if (typeof navigation !== 'undefined' && navigation !== null) {
  allButtons = navigation.querySelectorAll('.navigation-list > li > a');
  megaMenuButtons = navigation.querySelectorAll('.navigation-bar .megamenu-link > a');
  megaMenuContainers = navigation.querySelectorAll('.navigation-bar .megamenu-link > .megamenu-container');
  navigationItems = document.getElementsByClassName('navigation-item');

  for (var i = 0; i < megaMenuButtons.length; i++) {
    megaMenuButtons[i].addEventListener('click', function(event) {
      event.preventDefault();
      toggleMegaMenu(event.target);
    });
  }

  const topNavigationHeight = document.querySelector('.top-navigation').offsetHeight || 45,
    navSiteSearchResults = document.getElementById('nav-site-search-results');

  document.addEventListener('scroll', function() {
    adjustNavigationPosition(topNavigationHeight);
    adjustSearchResultsPosition(navSiteSearchResults, topNavigationHeight);
  });

  window.addEventListener('resize', function() {
    adjustNavigationPosition(topNavigationHeight);
    adjustSearchResultsPosition(navSiteSearchResults, topNavigationHeight);
  });

  document.documentElement.addEventListener('click', function(event) {
    if (displayedBox !== null) {
      if (!(isParent(event.target, navigation))) {
        toggleMegaMenu();
        displayedBox = null;
        document.body.classList.remove('megamenu-open');
      }
    }
  });

  const adLift = document.getElementById('service-ad-lift'),
    navSiteSearch = document.getElementById('nav-site-search');

  setupPosition(adLift);
  let prevInnerWidth = setupPosition(navSiteSearch);

  window.addEventListener('resize', () => {
    setupPosition(adLift, prevInnerWidth);
    prevInnerWidth = setupPosition(navSiteSearch, prevInnerWidth);
  });

  $('#megamenu-service-reservation').on('submit', function(e) {
    e.preventDefault();
    const license = $('.rekno').val();

    $.get('/stage-ajax/checkServiceStatus', { license: license}, function(data) {
      if (data[0]) {
        $('#megamenu-service-reservation .statustext').remove();
        $('#megamenu-service-reservation').append('<div class="statustext">' + data[0] + '</div>');
      }
      else if (data[1]) document.location.href = data[1];
      else { window.location = stage_language === 'fi' ? 'http://online.kayttoauto.fi/booking/fi/service/?reg=' + license : 'http://online.kayttoauto.fi/booking/sv/service/?reg=' + license;}
    },'json')
  });

  const navigationToggle = navigation.getElementsByClassName('toggle')[0],
    navigationList = navigation.getElementsByClassName('navigation-list')[0],
    megaMenu = navigation.getElementsByClassName('megamenu')[0];

  navigationToggle.addEventListener('click', function(event) {
    event.target.classList.toggle('menu-open');
    navigationList.classList.toggle('open');
    megaMenu.classList.toggle('menu-show');
    toggleMegaMenu();
    displayedBox = null;
    document.body.classList.remove('megamenu-open');
  });

  const collasibleToggles = navigation.getElementsByClassName('collasible-toggle'),
    targetCollasibles = navigation.getElementsByClassName('collasible-target');

  for (const toggle of collasibleToggles) {
    toggle.addEventListener('click', function(event) {
      event.preventDefault();

      for (const collasible of targetCollasibles) {
        if (collasible.dataset.collasibleId === event.target.dataset.target) {
          event.target.classList.toggle('open');
          collasible.classList.toggle('open');

          if (window.innerWidth <= mobileBreakPoint && collasible.classList.contains('open')) {
            event.target.scrollIntoView();
          }
        }
      }
    });
  }

  const navSiteSearchOpenButton = document.getElementById('nav-site-search-button'),
    navSiteSearchInput = document.getElementById('nav-site-search-input'),
    navSiteSearchInputContainer = document.getElementById('nav-site-search-input-container')

  navSiteSearchOpenButton.addEventListener('click', event => {
    if (window.innerWidth > mobileBreakPoint && displayedBox !== null) {
      toggleMegaMenu();
      displayedBox = null;
      document.body.classList.remove('megamenu-open');
    }

    navSiteSearchInputContainer.hidden = false;
    navSiteSearchResults.hidden = !navSiteSearchInput.value.length;
    event.target.classList.add('site-search-open');
    navSiteSearchInput.focus();

    Array.from(navigationItems).forEach(item => item.style.pointerEvents = 'none');
  });
}

function toggleMegaMenu(target = null) {
  let dataTarget;

  if (target !== null) {
    dataTarget = target.dataset.target;
  }

  for (let i = 0; i < allButtons.length; i++) {
    allButtons[i].classList.remove('fade');
  }

  for (let i = 0; i < megaMenuContainers.length; i++) {
    megaMenuButtons[i].classList.remove('show');
    megaMenuButtons[i].parentElement.classList.remove('selected');
    megaMenuContainers[i].classList.remove('show');

    if (megaMenuContainers[i].dataset.menuId === dataTarget) {
      if (megaMenuContainers[i].dataset.menuId !== displayedBox) {
        megaMenuButtons[i].classList.add('show');
        megaMenuButtons[i].parentElement.classList.add('selected');
        megaMenuContainers[i].classList.add('show');
        megaMenuContainers[i].style.top = navigation.offsetHeight + (parseInt(navigation.style.top) || 0) + 'px';

        for (let i = 0; i < allButtons.length; i++) {
          allButtons[i].classList.add('fade');
        }

        displayedBox = megaMenuContainers[i].dataset.menuId;
        document.body.classList.add('megamenu-open');
      } else {
        displayedBox = null;
        document.body.classList.remove('megamenu-open');
      }
    }
  }
}

function isParent(el, parent) {
  var p = el.parentNode;

  while (p !== document) {
    if (p === parent) {
      return true;
    }
    else {
      p = p.parentNode;
    }
  }

  return false;
}

function setupPosition(element, prevInnerWidth = 0) {
  if (
    !element ||
    window.innerWidth === prevInnerWidth
  ) {
    return prevInnerWidth;
  }

  const containers = document.querySelectorAll('[data-container-id="' + element.dataset.childId + '"]'),
    containersByType = {};

  for (let i = 0; i < containers.length; i++) {
    containersByType[containers[i].dataset.deviceType] = containers[i];
  }

  if (window.innerWidth > mobileBreakPoint) {
    containersByType.desktop.appendChild(element);
  }
  else {
    containersByType.mobile.appendChild(element);
  }

  return window.innerWidth;
}

function adjustNavigationPosition(topNavigationHeight) {
  if (window.innerWidth > mobileBreakPoint) {
    if (document.documentElement.scrollTop >= topNavigationHeight) {
      navigation.style.top = -(topNavigationHeight) + 'px';
    }
    else {
      navigation.style.top = -(document.documentElement.scrollTop) + 'px';
    }
  }
  else if (navigation.style.top !== 0) {
    navigation.style.top = 0;
  }
}

function adjustSearchResultsPosition(searchResults, topNavigationHeight, initialTop = 117) {
  if (window.innerWidth > mobileBreakPoint) {
    if (document.documentElement.scrollTop >= topNavigationHeight) {
      searchResults.style.top = initialTop - topNavigationHeight + 'px';
    }
    else {
      searchResults.style.top = initialTop - document.documentElement.scrollTop + 'px';
    }
  }
  else if (navigation.style.top) {
    searchResults.style.top = '';
  }
}
